import React from 'react';

export default class ChildProgressReviewSelectChildForm extends React.Component
{
	static get defaultProps() 
	{
	    return 
	    {
	      { mode: 'create'; userid: '' ; usertype:0; title: "" }
	    } ;
	}
	    
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		// Create a state item here for all items on the form  (Using their id )
		// If you don't create an initial entry here for each input field on the form, then React will assume they are
		// UNCONTROLLED and issue a warning at runtime
		//
		// displayErrors is passed to child controls for force them to display their validity state (for example if the SAVE button is pressed )
		
		if ( this.props.child == null )
		{
			var child = { firstname: '', surname: '' } ;
		}
		else
		{
			var child = this.props.child ;
		}
				
		this.state = {displayErrors: this.props.displayErrors ,
					child: child 
		};
	}

	UNSAFE_componentWillReceiveProps ( newProps )
	{
		this.processProps ( newProps ) ; 
	}

	processProps ( props )
	{
		this.setState ( { displayErrors: props.displayErrors} ) ;
	}

	formIsValid ()
	{
		if ( this.refs.InputReviewDate.isValid())
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}
	
	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}			
		}
	}
	
	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			// Just pass the click back to the creating form
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}		
	}

	onChildChange ( child )
	{
		if ( child != null )
		{
			var child = { firstname: child.firstname, surname: child.surname, child_id: child.child_id } ;
			this.setState ( {child: child });			
		}
		else
		{
			var child = { firstname: '', surname: '', child_id: 0 } ;
			this.setState ( {child: child });			
		}
	}
		
	inputElementWithLabel( validation, id , labelText, errorText  )
	{
        var lineList=[];
        
		var fieldType = '';
		
		if ( this.props.readonly == true )
		{
			fieldType = "readonly";
		}
		 
		var v = "" ;

        return React.createElement(UserInput, { key: this.keyCount++, errorText: errorText, displayErrors:this.state.displayErrors, parentRef: this.onChildRefNotify.bind(this) , labelText: labelText, validation: validation, keyValue: this.keyCount++, readOnly: fieldType, className: 'form-control', type: 'text', value: v , id: id, name: id, placeholder: labelText}) ;
	}
	
	clearFix()
	{
		return React.createElement ( 'div' , {  key: this.keyCount++, className: 'clearfix' } , null ) ;
	}

	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}

	topRow()
	{
        var lineList=[];	
		
        if ( this.props.mode == 'create' )
    	{
            var d = this.getFormattedDate (new Date());                 
    	}
        else
    	{
        	var d = "" ;
    	}
        
		var fieldType = '';
		
		if ( this.props.readonly == true || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}
		
		lineList.push (React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12'}, 
				React.createElement ( DropdownMyPEPChildren, {
	        	  validation: { required: true},
	        	  onChange: this.onChildChange.bind(this),
	        	  mode: 'list',
	        	  user_id: this.props.user_id,
				  id: 'InputSelectedChild', 
				  ref: 'InputSelectedChild', 
				  name: 'InputSelectedChild', 
				  labelText: 'Select a pupil',
				  errorText: 'You must select a pupil',
				  tabIndex: 1,
				  readOnly: fieldType, 
				  displayErrors:this.state.displayErrors,
				  key: this.keyCount++
				  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 50 },
			  name: 'InputFirstName',
			  ref: 'InputFirstName',
			  labelText: 'First Name', 
			  errorText: 'You must enter a valid first name',
			  value: this.state.child.firstname,
			  readOnly: "readonly", 
			  displayErrors:false,
			  key: this.keyCount++
			  }))) ;

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 50 },
			  ref: 'InputLastName',
			  name: 'InputLastName',
			  labelText: 'Last Name', 
			  errorText: 'You must enter a valid last name',
			  value: this.state.child.surname,
			  readOnly: "readonly", 
			  displayErrors:false,
			  key: this.keyCount++
			  }))) ;
        
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}	
	
	row2()
	{
        var lineList=[];	
		
        if ( this.props.mode == 'create' )
    	{
            var d = this.getFormattedDate (new Date());                 
    	}
        else
    	{
        	var d = this.state.child.dmy_date_of_birth ;
    	}
        
		var fieldType = '';
		
		if ( this.props.readonly == true || this.props.mode == 'view')
		{
			fieldType = "readonly";
		}

        lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'},
        	  React.createElement ( UserInput, { validation: { required: true, maxlen: 10, isDate: true },
			  id: 'InputReviewDate', 
			  name: 'InputReviewDate',
			  ref: 'InputReviewDate',
			  labelText: 'Review Date', 
			  errorText: 'You must enter a valid review Date',
			  value: d,
			  readOnly: fieldType, 
			  displayErrors:this.state.displayErrors,
			  key: this.keyCount++
			  }))) ;

		lineList.push ( React.createElement('div',  {key: this.keyCount++, className: 'col-md-6'})) ;
		
        return React.createElement('div',  {key: this.keyCount++, className: 'row'}, lineList );
	}	
	
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	formRow ()
    {
        return React.createElement('div', { key: this.keyCount++}, this.col1FieldList(), this.col2FieldList()) ;
    }
	
	buttonRow ()
    {
        var lineList=[];
        

        lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

        lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3'},
        		 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right' } , onClick: this.onSave.bind(this) }, 'Confirm'),
           		 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px' }, onClick: this.onCancel.bind(this) }, 'Cancel')))
           		        
        return React.createElement('div', { key: this.keyCount++ }, lineList );
    }
    
	mainFormElement ()
    {
	    var lineList=[];
	    
	    lineList.push ( this.topRow()) ;
	    lineList.push ( this.row2()) ;
	    lineList.push ( this.buttonRow()) ;
	    
	    return lineList;
    }

	render() 
    {
		this.keyCount=0;
        return React.createElement('div', { className: 'panel'},
        		React.createElement ('div', { className: 'panel-body'}, this.mainFormElement()));
    }
};